import { render, staticRenderFns } from "./Customizer.vue?vue&type=template&id=9b7b8a92&scoped=true&"
import script from "./Customizer.vue?vue&type=script&lang=js&"
export * from "./Customizer.vue?vue&type=script&lang=js&"
import style0 from "./Customizer.vue?vue&type=style&index=0&id=9b7b8a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7b8a92",
  null
  
)

export default component.exports